import { teladocApi, TdApiRoutes, authToken } from '@td/api';

import {
  FETCH_VENDORS
} from './actionTypes';

const fetchVendors = consultationId => ({
  type:    FETCH_VENDORS,
  payload: teladocApi.get(
    TdApiRoutes.forConsult(consultationId).vendors(),
    null,
    authToken.get()
  )
});

export {
  fetchVendors
};
